import { apiService } from './apiService';
import ToastMe from '../components/ui/ToastMe';

export function getRoleService(data) {
    return apiService({
        method: 'POST',
        url: '/role/data',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function getByIdRoleService(id) {
    return apiService({
        method: 'GET',
        url: '/role/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function addRoleService(data) {
    return apiService({
        method: 'POST',
        url: '/role',
        data,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}

export function updateRoleService(id, data) {
    return apiService({
        method: 'PUT',
        url: '/role/' + id,
        data,
        onSuccess: (dispatch, res) => {
            ToastMe(res.data.message, 'success');
        },
        onFailure: () => {},
    });
}

export function deleteRoleService(id) {
    return apiService({
        method: 'DELETE',
        url: '/role/' + id,
        onSuccess: (dispatch, res) => {},
        onFailure: () => {},
    });
}
export const fetchRoleByValue = (value) =>
  apiService({ method: 'GET', url: '/role/find-by', params: { value } });

// somewhere in ChefServices.js
const getChefRoleId = async () => {
  const { data } = await fetchRoleByValue('chef');
  return data._id;           // ← cache this if you like
};
